var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToiletHoverPinGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    in: "SourceAlpha",
    operator: "dilate",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.588 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#313131",
    cx: 12,
    cy: 35.264,
    rx: 3.736,
    ry: 3.736
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.736 12.427c0-3.38 2.735-6.12 6.116-6.12 3.38 0 6.12 2.74 6.12 6.12 0 3.383-2.74 6.12-6.12 6.12s-6.116-2.737-6.116-6.12",
    opacity: 0.896,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.792 11.315c0 6.635 11.256 22.603 11.256 22.603S23.305 17.95 23.305 11.315C23.305 5.387 18.292.54 12.048.54 5.805.54.792 5.386.792 11.314zm11.256-4.38c2.962 0 5.36 2.4 5.36 5.36 0 2.965-2.398 5.362-5.36 5.362S6.69 15.26 6.69 12.297c0-2.962 2.396-5.362 5.358-5.362z",
    fill: "green",
    filter: "url(#a)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletHoverPinGreen);
export default __webpack_public_path__ + "static/media/toilet-hover-pin-green.de57e11adddd330694b48ece371aaea5.svg";
export { ForwardRef as ReactComponent };